import type { ProjectFile } from '../store'
import { useStore } from '../store'

// GĐ8 — Lưu/mở "file dự án": chỉ chứa quyết định biên tập (không kèm video).
// Media được liên kết lại theo TÊN clip khi mở — giống file dự án của phần mềm dựng chuyên nghiệp.

export function saveProjectFile(): void {
  const s = useStore.getState()
  const project: ProjectFile = {
    app: 'brandcut',
    version: 1,
    clips: s.clips.map((c) => ({ name: c.name, words: c.words, cuts: c.cuts })),
    style: s.style,
    exportFormats: s.exportFormats,
  }
  const blob = new Blob([JSON.stringify(project, null, 2)], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = 'brandcut-project.json'
  a.click()
  URL.revokeObjectURL(url)
}

export async function loadProjectFile(file: File): Promise<string> {
  const text = await file.text()
  let parsed: ProjectFile
  try {
    parsed = JSON.parse(text)
  } catch {
    return '⚠️ File dự án không hợp lệ.'
  }
  if (parsed?.app !== 'brandcut') return '⚠️ Đây không phải file dự án BrandCut.'
  const matched = useStore.getState().applyProject(parsed)
  if (matched === 0)
    return '⚠️ Đã mở dự án nhưng chưa khớp clip nào — hãy thêm đúng các video cùng tên rồi mở lại.'
  return `📂 Đã mở dự án, khớp ${matched}/${parsed.clips.length} clip theo tên.`
}
